import { useEffect, useState } from "react";
import { Col, Nav, Row, Tab } from "react-bootstrap";
import { Helmet } from "react-helmet-async";
import { useSelector } from "react-redux";

import { useNavigate, useParams } from "react-router-dom";
import LoadingComp from "../../components/re-usable/loading/loading";
import CoursesTabContent from "../../components/tabs/courses-tab-content";
import TwoColumnLayOut from "../../layouts/two-columns/two-column-layout";
import { retrieveBooksTabs } from "../../redux/slice/education/books-tabs-slice";
import { retrieveCatalogPath } from "../../redux/slice/education/catalog-path-slice";
import { RootState, useAppDispatch } from "../../redux/store";
import { retrievePageMenu } from "../../redux/slice/page-menu.slice";

const Books = () => {
  const navigator = useNavigate();
  const params = useParams();
  const dispatch = useAppDispatch();
  const path = "%2FEducation%2FBooks";
  const [tabName, setTabName] = useState<string>(params.tabName || "All");
  const [pageNumber, setPageNumber] = useState<number>(1);
  const { BooksTabsData, BooksTabsLoading } = useSelector((state: RootState) => state.BooksTabs);
  const { CatalogPathData } = useSelector((state: RootState) => state.CatalogPath);
  const { RapsEuropeData } = useSelector((state: RootState) => state.rapsEurope);

  const [isPublished, setIsPublished] = useState(false);

  const pageTabsData = [
    {
      displayText: "All",
      pathName: "all",
    },
    //{
    //  displayText: "Fundamentals Series",
    //  pathName: "fundamentals",
    //},
    {
      displayText: "Medical Devices",
      pathName: "medical-devices",
    },
    {
      displayText: "Pharmaceuticals",
      pathName: "pharmaceuticals",
    },
    {
      displayText: "Biotechnology",
      pathName: "bio-technology",
    },
    {
      displayText: "Business/Career Development",
      pathName: "business-career-development",
    },
    {
      displayText: "Subscriptions",
      pathName: "subscriptions",
    },
  ];

  const queryParams = {
    path: tabName,
    pageNumber: pageNumber,
  };

  const updateUrl = (tabName?: string) => {
    tabName && navigator(`/education/books/${tabName}`);
  };

  useEffect(() => {
    dispatch(retrieveBooksTabs(queryParams));
    dispatch(retrieveCatalogPath(path));
    dispatch(retrievePageMenu(path));
  }, [dispatch]);

  useEffect(() => {
    dispatch(retrieveBooksTabs(queryParams));
  }, [tabName, pageNumber]);

  // On tab change
  const handleSearchType = (displayName: string) => {
    setTabName(displayName);
    setPageNumber(1);
    updateUrl(displayName);
  };

  // Choose page number
  const choosePageNumber = (pageNumber: number) => {
    setPageNumber(pageNumber);
  };

  useEffect(() => {
    if (RapsEuropeData[0]?.result !== undefined) {
      setIsPublished(true);
    }
  }, [RapsEuropeData]);

  if (!isPublished) return <LoadingComp />;

  return (
    <>
      <Helmet>
        <title>{RapsEuropeData[0]?.result[0]?.menuItemName}</title>
      </Helmet>
      <TwoColumnLayOut breadcrumbPath={""} isBreadcrumbpath={false} showAds={true}>
        <div dangerouslySetInnerHTML={{ __html: CatalogPathData[0]?.text }}></div>
        {/* <h1>Books Catalog</h1> */}
        <div className="tabbs courses">
          <Tab.Container id="left-tabs-example" defaultActiveKey={params.tabName || "all"}>
            <Row>
              <Col sm={12}>
                <Nav className="d-flex nav-tabs flex-wrap">
                  {pageTabsData &&
                    pageTabsData?.map((tab, index) => {
                      const displayText = tab.pathName;
                      return (
                        <Nav.Item key={index}>
                          <Nav.Link eventKey={tab.pathName} onClick={() => handleSearchType(displayText)}>
                            <span className="searchtag" style={{ verticalAlign: "top" }}>
                              {tab.displayText}
                            </span>
                          </Nav.Link>
                        </Nav.Item>
                      );
                    })}
                </Nav>
              </Col>
              {BooksTabsLoading ? (
                <LoadingComp />
              ) : (
                <Col sm={12}>
                  <Tab.Content className="category">
                    <Tab.Pane eventKey="all" className="first-row-gray-color">
                      <CoursesTabContent tabContent={BooksTabsData} choosePageNumber={choosePageNumber} pageNumber={pageNumber} isPagination={false} />
                    </Tab.Pane>
                    <Tab.Pane eventKey="medical-devices" className="intro">
                      <CoursesTabContent tabContent={BooksTabsData} choosePageNumber={choosePageNumber} pageNumber={pageNumber} isPagination={true} />
                    </Tab.Pane>
                    <Tab.Pane eventKey="pharmaceuticals" className="intro">
                      <CoursesTabContent tabContent={BooksTabsData} choosePageNumber={choosePageNumber} pageNumber={pageNumber} isPagination={true} />
                    </Tab.Pane>
                    <Tab.Pane eventKey="bio-technology" className="intro">
                      <CoursesTabContent tabContent={BooksTabsData} choosePageNumber={choosePageNumber} pageNumber={pageNumber} isPagination={true} />
                    </Tab.Pane>
                    <Tab.Pane eventKey="business-career-development" className="intro">
                      <CoursesTabContent tabContent={BooksTabsData} choosePageNumber={choosePageNumber} pageNumber={pageNumber} isPagination={false} />
                    </Tab.Pane>
                    <Tab.Pane eventKey="subscriptions" className="intro">
                      <CoursesTabContent tabContent={BooksTabsData} choosePageNumber={choosePageNumber} pageNumber={pageNumber} isPagination={false} />
                    </Tab.Pane>
                  </Tab.Content>
                </Col>
              )}
            </Row>
          </Tab.Container>
        </div>
      </TwoColumnLayOut>
    </>
  );
};

export default Books;
